import { createContext } from "react";

const artworkContext = createContext();

export default artworkContext;
